// extracted by mini-css-extract-plugin
export default {"faqContainer":"Join_faqContainer__O-IK+"};